import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import commonReducer from "./common.reducer";
import tableReducer from "./table.reducer";
import dropdownsReducer from "./dropdowns.reducer";
import companyReducer from "./company.reducer";
import userReducer from "./user.reducer";
import skillsReducer from "./skills.reducer";
import companyProfileReducer from "./companyProfile.reducer";
import { reducer as reduxFormReducer } from "redux-form";
import projectReducer from "./project.reducer";
import citiesReducer from "./cities.reducer";
import workReferencesReducer from "./workReferences.reducer";
import adminReducer from "./admin.reducer";
import invoiceReducer from "./invoice.reducer";

export default combineReducers({
  routing: routerReducer,
  common: commonReducer,
  table: tableReducer,
  dropdowns: dropdownsReducer,
  company: companyReducer,
  user: userReducer,
  skills: skillsReducer,
  form: reduxFormReducer,
  companyProfile: companyProfileReducer,
  project: projectReducer,
  cities: citiesReducer,
  workReferences: workReferencesReducer,
  admin: adminReducer,
  invoice: invoiceReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js